export default __webpack_public_path__ + "static/media/resources-icon.fbe452cd.png";